export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board.vue?vue&type=template&id=0f2037d3&"


//////////////////
// WEBPACK FOOTER
// ./src/views/board/board.vue?vue&type=template&id=0f2037d3&
// module id = null
// module chunks = 